export const getCreationContainerContentStyle = () => ({
  flex: 1,
  overflow: 'auto',
  '& .ba-backbone-instance-wrapper': {
    height: '100%',
    overflow: 'auto',

    '& >div': {
      height: '100%',
      overflow: 'auto',

      '& .audience-campaign-creation-wizard-container': {
        height: '100%',
        overflow: 'auto',
        '& .audience-campaign-creation-wizard': {
          height: '100%',
          overflow: 'auto',

          '& div[data-current-step-name^="audience-campaign-creation-wizard-step"]': {
            height: '100%',
            overflow: 'auto',
          },
        },
      },

      '& .audience-adgroup-creation-wizard-container': {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'auto',

        '& .audience-adgroup-creation-wizard': {
          flex: 1,

          '& div[data-current-step-name^="audience-adgroup-creation-wizard-step"]': {
            height: '100%',
          },
        },
      },
    },
  },
});

export const CreationContainerContentOverrideStyle = {
  // TODO: This is a temporary fix
  '.app-content-body': {
    flex: '1',
    overflow: 'auto',
  },
};
